/**
 * Export component file to be used on project
 */

import HeaderMenu from './HeaderMenu';
export default HeaderMenu;